import(/* webpackMode: "eager" */ "/var/www/mindbalance-web/src/app/(Auth)/professional-info/page.js")